import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { CodeTextListComponent } from '../code-text-list/code-text-list.component';
import { PageCode } from '../../../../common/page-code/page-code';
import '../../../../common/extension/form-group-extension';
import { HrResourceName } from '../../../../common/model/hr-resource-name';
import { CodeTextFormComponent } from '../code-text-form/code-text-form.component';
import { HrBasePageNew } from '../../../../common/base-form/hr-base-page-new';
import { DropdownOption, UiTranslateLoaderService } from 'ui-shared';
import { ActivatedRoute } from '@angular/router';
import { PageCodeModel } from '../../../../common/page-code/page-code-model';
import {HvlFormConstants} from "@hvlng/framework-core/form";

@Component({
    selector: 'code-text-page',
    templateUrl: './code-text-page.component.html',
})
export class CodeTextPageComponent extends HrBasePageNew implements OnInit {
    @ViewChild(CodeTextListComponent) listComponent: CodeTextListComponent;
    @ViewChild(CodeTextFormComponent) formComponent: CodeTextFormComponent;

    selectedDiscriminator: DropdownOption = null;
    selectedItem: any;
    addButtonDisabled = true;
    pageCodeModelA = new PageCodeModel(PageCode.CODE_TEXT);

    constructor(
        private uiTranslateLoaderService: UiTranslateLoaderService,
        private injector: Injector,
        protected activatedRoute: ActivatedRoute,
    ) {
        super(PageCode.CODE_TEXT, injector);
    }

    ngOnInit(): void {
        if (
            this.activatedRoute.snapshot['_routerState'].url &&
            this.activatedRoute.snapshot['_routerState'].url.includes('personnel')
        ) {
            this.pageCodeModelA = new PageCodeModel(PageCode.CODE_TEXT_PERSONNEL);
        } else if (
            this.activatedRoute.snapshot['_routerState'].url &&
            this.activatedRoute.snapshot['_routerState'].url.includes('payroll')
        ) {
            this.pageCodeModelA = new PageCodeModel(PageCode.CODE_TEXT_PAYROLL);
        } else if (
            this.activatedRoute.snapshot['_routerState'].url &&
            this.activatedRoute.snapshot['_routerState'].url.includes('performance')
        ) {
            this.pageCodeModelA = new PageCodeModel(PageCode.CODE_TEXT_PERFORMANCE);
        }
    }

    onResourcesLoaded() {
        this.pageTitle = this.translateSync(this.hrKey.hrCommonCodeText.pageHeader);
    }

    getResourceList(): Array<HrResourceName> {
        return [HrResourceName.hrComCodeText];
    }

    getFormComponent(): CodeTextFormComponent {
        return this.formComponent;
    }

    getListComponent(): CodeTextListComponent {
        return this.listComponent;
    }

    onDiscriminatorValueChanged(discriminatorValue: DropdownOption) {
        this.onFormClosed(false);
        this.selectedDiscriminator = discriminatorValue;
        this.setAddButtonDisabled(discriminatorValue == null);
        if (discriminatorValue == null) {
            this.pageTitle = null;
            return;
        }
        this.setPageTitle();
    }

    setPageTitle() {
        if (this.selectedDiscriminator?.label != null) {
            this.pageTitle = this.selectedDiscriminator?.label + ' ' + this.translateSync(this.hrKey.hrCommonCodeText.info);
        }
    }

    onFormClosed(refreshTable: boolean) {
        super.closeForm();
        this.setAddButtonDisabled(false);
        this.getListComponent()?.clearSelectedItem();

        this.formMode = HvlFormConstants.LIST;
        if(refreshTable){
            this.getListComponent()?.dataTableRef.reset();
        }
    }

    setAddButtonDisabled(disabled: boolean) {
        this.addButtonDisabled = disabled;
    }

    onRowSelected(selectedItem: any) {
        this.selectedItem = selectedItem;
        this.setButtonItemSelectedMode();
    }

    onRowUnSelected() {
        this.setButtonItemUnSelectedMode();
    }

    setButtonsDisabledState(disabled: boolean) {
        this.copyButtonDisabled = disabled;
        this.editButtonDisabled = disabled;
        this.removeButtonDisabled = disabled;
    }

    onSearchCleared() {
        this.pageTitle = null;
        this.closeForm();
        this.addButtonDisabled = true;
    }

    protected setButtonItemSelectedMode() {
        super.setButtonItemSelectedMode();
        this.removeButtonDisabled = !this.selectedItem?.enabled;
        this.editButtonDisabled = !this.selectedItem?.enabled;
    }
}
